import axios from 'axios'

const client = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: false,
  timeout: 60000
})

export default {
  // Photos
  listPhotos(params) {
    return client.patch('/photos/list', params)
  }
}